import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

/**
 * Release Auto Transfers
 *
 * Auto releases the pending pure transfers into locations whose inbound mode
 * is auto-stage, ranked and up to each source's daily line cap, exactly as
 * the replenishment engine's last phase does. Lines past a cap stay queued
 * for a later day.
 *
 * Schedule its workflow at the time transfers should drop each day, and set
 * the published supply network to release "on a schedule" so the engine
 * leaves the lines for this step (GEN-3027).
 */
export const releaseAutoTransfersStep = defineStepConfig({
  type: "release_auto_transfers",
  name: "Release Auto Transfers",
  description:
    "Auto releases pending transfers into auto-stage locations as draft transfer orders, ranked (customer orders, then out-of-stocks, then ABC class) and up to each source's daily line cap from the published supply network. Lines past a cap stay queued for a later day. Schedule it at the time transfers should drop.",
  category: "Transformation",
  libraryModule: "Procurement",
  inputSchema: z.object({
    divisionId: z
      .string()
      .uuid()
      .optional()
      .describe("Release only transfers into this division"),
  }),
  outputSchema: z.object({
    autoStagedTransferOrders: z.number(),
    autoStagedSuggestions: z.number(),
    autoStageRequiresApproval: z.number(),
    autoReleaseQueued: z
      .number()
      .describe("Lines left for a later day by a source's daily line cap"),
  }),
  configSchema: z.object({
    dryRun: z.boolean().prefault(false).describe("If true, release nothing"),
  }),
  emits: [] as const,
  execution: {
    startToCloseTimeout: "15 minutes",
    retry: { maximumAttempts: 2 },
  },
});
